<template>
  <el-dialog
      title="查看发票"
      append-to-body
      :visible.sync="visible"
      width="700px"
      :before-close="handleClose">

    <img v-loading="loading" :src="base64" class="img-code" alt/>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :disabled="loading" @click="handleDownload">下 载</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "invoiceImg",
  props:{
    visible: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => {}
    },
  },
  data(){
    return{
      base64: '',
      loading: true
    }
  },
  created() {
    this.getInvoiceImg()
  },
  methods:{
    handleDownload(){
      this.saveBase64Image(this.base64)
    },
    saveBase64Image(base64) {
      // 创建一个 Blob 对象
      var byteCharacters = atob(base64.split(",")[1]);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], { type: "image/png" });

      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.href = url;
      link.download = "发票.png"; // 设置下载文件名
      document.body.appendChild(link); // 将链接添加到页面
      link.click(); // 触发下载
      document.body.removeChild(link); // 下载完成后移除链接
      URL.revokeObjectURL(url); // 释放 URL 对象
    },
    getInvoiceImg(){
      this.loading = true
      this.$http.get(this.$api.invoice.getInvoiceImg + this.product.tradeNo).then((res) => {
        if (res.data.code == 200) {
          this.base64 = "data:image/png;base64," + res.data.msg;
          this.loading = false;
        }else {
          this.$message.error(res.data.msg);
          this.loading = false
        }
      })
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">
.img-code {
  width: 660px;
}
</style>
